var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMailOptions255X177(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "255px",
    height: "177px",
    viewBox: "0 0 255 177",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/mailoptions/255x177") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/mailoptions/255x177",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "package",
    transform: "translate(76, 29)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.4028733,0.73261685 L2.08767879,25.3197054 C0.802984622,26.0016534 0,27.337118 0,28.7919945 L0,90.5105217 C0,93.0035514 1.40085684,95.2845639 3.62378796,96.4120729 L49.0413618,119.448024 C50.4905521,120.18318 52.2033422,120.18318 53.6521263,119.448024 L99.0701063,96.4120729 C101.293037,95.2845639 102.693894,93.0031452 102.693894,90.5105217 L102.693894,28.7919945 C102.693894,27.337118 101.89091,26.0016534 100.605809,25.3197054 L54.291021,0.73261685 C52.4502894,-0.244205617 50.244011,-0.244205617 48.4028733,0.73261685 Z",
    id: "Path",
    fill: "#FFCE94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3471502,120 C52.1375438,120 52.9283435,119.816414 53.6525325,119.448837 L99.0705125,96.4128852 C101.293444,95.2853762 102.6943,93.0039576 102.6943,90.5113341 L102.6943,28.7919945 C102.6943,28.1494444 102.530211,27.5345133 102.244678,26.9845683 L51.3471502,54.093118 L51.3471502,120 Z",
    id: "Path",
    fill: "#FCB043"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3471502,54.093118 L0.450028812,26.9841622 C0.164089928,27.5341071 0,28.1490382 0,28.7915884 L0,90.5105217 C0,93.0035514 1.40085684,95.2845639 3.62378796,96.4120729 L49.0413618,119.448024 C49.7659569,119.815602 50.5563505,119.999188 51.3471502,119.999188 L51.3471502,54.093118 L51.3471502,54.093118 Z",
    id: "Path",
    fill: "#E2791B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.493303,8.80267323 L17.9828751,36.2345288 L17.9828751,45.0121214 C17.9828751,45.8545039 18.4475258,46.6282448 19.1908045,47.02466 L28.1426411,51.795859 C28.8530205,52.1744031 29.710431,51.6597943 29.710431,50.8547789 L29.710431,42.6624674 L81.300873,15.0709897 L69.493303,8.80267323 Z",
    id: "Path",
    fill: "#07A0C9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(58.7673, 89.1337)",
    fill: "#F41381"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,13.3513183 L13.7417191,6.77919177 C15.5012181,5.93802781 16.6031388,4.14238035 16.5568362,2.19279705 L16.5556177,2.13187257 C16.5174384,0.523466347 14.8099283,-0.491535459 13.3786092,0.243619911 L0.000406163188,7.1142764 L0.000406163188,13.3513183 L0,13.3513183 L0,13.3513183 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,22.9343326 L7.54610587,19.4287381 C9.33281773,18.5981344 10.4582959,16.7882712 10.4115872,14.8183797 L10.4115872,14.8183797 C10.3734078,13.2042872 8.65614986,12.1896916 7.22401846,12.9354072 L0,16.6964783 L0,22.9343326 Z",
    id: "Path"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M17.982469,36.3226662 L17.982469,45.0121214 C17.982469,45.8545039 18.4471197,46.6282448 19.1903983,47.02466 L28.142235,51.795859 C28.8526144,52.1744031 29.7100249,51.6597943 29.7100249,50.8547789 L29.7100249,42.6624674 L29.79735,42.6157586 C26.7653418,41.0008538 21.8406131,38.3774458 17.982469,36.3226662 Z",
    id: "Path",
    fill: "#07A0C9"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailOptions255X177);
export default __webpack_public_path__ + "static/media/mail-options_255x177.342b819557035de718ebf9cec1445449.svg";
export { ForwardRef as ReactComponent };